import { useEffect, useRef } from 'react'
import classNames from 'classnames'
import gsap from 'gsap'
import injectSheet from 'react-jss'
import useScrollTrigger from '@/hooks/useScrollTrigger'
import style from './style'

const CardIcon = ({
  classes,
  icon,
  text,
  background,
  rotate,
  y,
}) => {
  const { animationReady } = useScrollTrigger()
  const $root = useRef()

  useEffect(() => {
    if (animationReady) {
      gsap.to($root.current, {
        scrollTrigger: {
          trigger: $root.current,
          scrub: true,
          start: 'top 100%',
          end: 'bottom 50%',
          once: false,
        },
        rotate,
        y,
        ease: 'none',
      })
    }
  }, [animationReady])

  return (
    <div
      className={classNames({
        [classes.card]: true,
        cardIcon: true,
        [classes.cardBackgroundPrimary]: background === 'primary',
        [classes.cardBackgroundSecondary]: background === 'secondary',
      })}
      ref={$root}
    >
      <div>
        <div className={classes.cardIcon}>
          <svg><use xlinkHref={`#ico-${icon}`} /></svg>
        </div>
        <div
          className={classes.cardInfo}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  )
}

export default injectSheet(style)(CardIcon)
